<form [formGroup]="userForm">
  <div class="password-wrapper">
    <label for="username">{{ "userPass.usernameLabel" | translate }}</label>
    <input
      id="username"
      formControlName="username"
      [readonly]="selectedUsername === loggedInUser.username"
    />
  </div>

  <div class="password-wrapper">
    <label for="password">{{ "userPass.passwordLabel" | translate }}</label>
    <input
      id="password"
      [type]="showPassword ? 'text' : 'password'"
      formControlName="password"
    />
    <button type="button" class="eye-btn" (click)="togglePasswordVisibility()">
      <span class="material-icons-outlined">{{
        showPassword ? "visibility_off" : "visibility"
      }}</span>
    </button>
    <messages
      class="msg"
      [form]="userForm"
      [messagesObserver]="messages"
      fieldname="password"
    >
    </messages>
  </div>

  <div class="password-wrapper">
    <label for="confirmation">{{
      "userPass.confirmationLabel" | translate
    }}</label>
    <input
      id="confirmation"
      [type]="showConfirmation ? 'text' : 'password'"
      formControlName="confirmation"
    />
    <button
      type="button"
      class="eye-btn"
      (click)="toggleConfirmationVisibility()"
    >
      <span class="material-icons-outlined">{{
        showConfirmation ? "visibility_off" : "visibility"
      }}</span>
    </button>
    <messages
      class="msg"
      [form]="userForm"
      [messagesObserver]="messages"
      fieldname="confirmation"
    >
    </messages>
  </div>

  <div class="buttons-wrapper">
    <action-button
      class="btn-save"
      (actionEvent)="savePass($event)"
      icon="save"
    >
    </action-button>
    <button class="cancel" type="button" (click)="cancelPasswordChange()">
      <span class="material-icons-outlined">cancel</span>
    </button>
  </div>
</form>
